import { render, staticRenderFns } from "./BillingDetailsReport.vue?vue&type=template&id=5e8d95ad&"
import script from "./BillingDetailsReport.vue?vue&type=script&lang=ts&"
export * from "./BillingDetailsReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports